<template>
  <div class="text-left">
    <div style="height:570px; overflow-y:auto;">
      <!-- <b-spinner
      v-if="isLoading"
      type="grow"
      class="text-center"
      style="margin-top: 10%; position:absolute;"
      variant="primary"
      ></b-spinner>-->
      <b-card-group deck>
        <b-card class="mb-5" header="Add / Edit Company Keyword" header-tag="header">
          <b-form>
            <b-row>
              <b-col cols="6">
                <b-form-group label="Company Keyword:">
                  <b-form-input
                    v-model="companyKeyword"
                    type="text"
                    placeholder="Enter Company Keyword"
                  ></b-form-input>
                </b-form-group>
              </b-col>

              <b-col cols="6">
                <b-form-group label="Is Deleted?">
                  <b-form-select :options="isDeletedOptions" v-model="isDeleted" class="mb-3"></b-form-select>
                </b-form-group>
              </b-col>
            </b-row>

            <b-button variant="secondary">Submit</b-button>
          </b-form>
        </b-card>
      </b-card-group>
      <b-card-group deck>
        <b-card header="Company Keywords" header-tag="header">
          <b-navbar toggleable="lg" type="dark" variant="light">
            <b-navbar-brand href="#" class="text-dark">
              <strong>Manage Escape Keywords</strong>
            </b-navbar-brand>
            <b-navbar-nav class="ml-auto">
              <b-nav-form>
                <b-form-group
                  label-cols-sm="3"
                  label-align-sm="right"
                  label-size="sm"
                  label-for="filterInput"
                >
                  <b-input-group size="sm">
                    <b-form-input
                      v-model="filter"
                      type="search"
                      id="filterInput"
                      placeholder="Type to Search"
                    ></b-form-input>
                    <b-input-group-append>
                      <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-nav-form>
            </b-navbar-nav>
          </b-navbar>

          <b-table
            class="mx-1"
            sticky-header="calc(100vh - 200px)"
            ref="table"
            bordered
            id="users-data-table"
            :busy.sync="isLoading"
            :items="items"
            :fields="fields"
            :filter="filter"
            :per-page="perPage"
            :current-page="currentPage"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            responsive="sm"
          ></b-table>
          <b-row>
            <b-col cols="2">
              <b-form-select v-model="perPage" id="perPageSelect" size="sm" :options="pageOptions"></b-form-select>
            </b-col>
            <b-col>
              <b-pagination
                class="float-right"
                v-model="currentPage"
                :total-rows="rows"
                :per-page="perPage"
                first-text="First"
                prev-text="Prev"
                next-text="Next"
                last-text="Last"
                aria-controls="my-table"
              ></b-pagination>
            </b-col>
          </b-row>
        </b-card>
      </b-card-group>
    </div>
  </div>
</template>

<script>
// import { HTTP } from "../../utils/HTTP";
export default {
  name: "clientProfileManageThirdParties",
  components: {},
  data() {
    return {
      isDeletedOptions: [
        { value: null, text: "-- Please select an option --" },
        { value: 0, text: "No" },
        { value: 1, text: "Yes" }
      ],
      companyKeyword: null,
      isDeleted: null,
      perPage: 10,
      totalRows: 0,
      currentPage: 1,
      sortBy: "id",
      sortDesc: false,
      pageOptions: [5, 10, 25, 50, 75, 100],
      items: [],
      isLoading: false,
      filter: null,
      fields: [
        {
          key: "company_keyword",
          label: "Company Keyword",
          sortable: true
        },
        {
          key: "created_by",
          label: "Created By",
          sortable: true
        },
        {
          key: "created_on",
          label: "Created On",
          sortable: true
        },
        {
          key: "Actions",
          label: "Actions",
          sortable: false
        }
      ]
    };
  },
  computed: {
    rows() {
      return this.totalRows;
    }
  },
  mounted() {},
  methods: {}
};
</script>

<style scoped>
</style>
